import React from "react";
import {Box, Paper, Skeleton, Typography} from "@mui/material";

interface DailyReportTotalizerCardProps {
    icon: React.ReactNode;
    title: string;
    value: string;
    unit: string;
    subtitle: string;
    loading?: boolean;
}

export default function DailyReportTotalizerCard({
                                                     icon,
                                                     title,
                                                     value,
                                                     unit,
                                                     subtitle,
                                                     loading = false,
                                                 }: DailyReportTotalizerCardProps) {
    return (
        <Paper
            elevation={0}
            sx={{
                position: "relative",
                height: "100%",
                p: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                display: "flex",
                flexDirection: "column",
                gap: 1,
            }}
        >
            <Box sx={{display: "flex", alignItems: "center", gap: 1.5}}>
                <Box
                    sx={{
                        flexShrink: 0,
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        backgroundColor: "primary.main",
                    }}
                >
                    {icon}
                </Box>
                <Typography
                    variant="h6"
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: "1.25rem",
                        lineHeight: 1.6,
                        letterSpacing: "0.15px",
                    }}
                >
                    {title}
                </Typography>
            </Box>

            <Box sx={{display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 1, flexWrap: "wrap"}}>
                {loading ? (
                    <Skeleton variant="text" width={130} height={32}/>
                ) : (
                    <Typography variant="h6" sx={{fontWeight: 500, color: "primary.main"}}>
                        {`${value} ${unit}`}
                    </Typography>
                )}
                <Typography variant="caption" sx={{color: "text.secondary"}}>
                    {subtitle}
                </Typography>
            </Box>
        </Paper>
    );
}
